import React, { Fragment } from 'react';
import { withRouter } from 'react-router';
import styled from 'styled-components/macro';

import capitalize from 'lodash.capitalize';

import TippyToolTip from 'components/base/TippyToolTip/TippyToolTip';
import modularScale from 'styles/helpers/modular-scale';

import { possibleFilters } from 'config';
import { EntityContext } from 'context/entityContext';
import FilterDisplayName from 'components/utility/FilterDisplayName/FilterDisplayName';
import getFiltersFromUrl from 'helpers/getFiltersFromUrl';

export const ActiveFiltersText = styled.div<any>`
  font-size: ${({ newDesign }): string =>
    newDesign ? '16px' : modularScale(-1)};
`;

const Relative = styled.div`
  position: relative;
  display: inline;
`;

const ActiveFilters: React.FC<any> = (props: any) => {
  const { allowedFilters, location, newDesign } = props;
  const { compareMode } = React.useContext(EntityContext);

  const filters = getFiltersFromUrl(location);

  const appliedFilters = React.useMemo(() => {
    if (!allowedFilters) return null;

    return possibleFilters
      .filter(filterAllowedFilters)
      .sort(sortRegionAndCountry);

    function sortRegionAndCountry(a: string, b: string): any {
      if (a === 'customRegion' && b === 'region') return -1;

      if (a === 'region' && b === 'country') return -1;
      if (a === 'country' && b === 'region') return 1;
      return 0;
    }

    function filterAllowedFilters(filter: string): boolean {
      const notCountry = filter !== 'country' || compareMode !== 'country';
      const isAllowed = allowedFilters.includes(filter);
      const isActive = filter in filters;
      return isActive && isAllowed && notCountry;
    }
  }, [compareMode, allowedFilters, filters]);

  return (
    <ActiveFiltersText newDesign={newDesign}>
      Applied Filters:{' '}
      {appliedFilters && appliedFilters.length > 0 ? (
        appliedFilters.map((filter, index) => {
          const tooltipContent = `${capitalize(filter)} filter`;
          return (
            <Fragment key={`active-filters-${filter}-${filters[filter]}`}>
              {index !== 0 && ', '}
              <Relative data-pw="active-filters-applied-results">
                <TippyToolTip
                  delay={[0, 250]}
                  interactive={false}
                  tooltipContent={tooltipContent}
                >
                  <FilterDisplayName
                    filter={filter}
                    filterId={filters[filter] as any}
                  />
                </TippyToolTip>
              </Relative>
            </Fragment>
          );
        })
      ) : (
        <Fragment key={`active-filters-none}`}>
          <Relative data-pw="active-filters-applied-results">None</Relative>
        </Fragment>
      )}
    </ActiveFiltersText>
  );
};

export default withRouter(ActiveFilters);
